/** Shared size and stroke for the user settings headings. */
export function SettingsIcon({ name }: { name: "language" | "timer" | "password" | "beta" }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {name === "language" ? <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a18 18 0 0 1 0 18 18 18 0 0 1 0-18Z" />
      </> : name === "timer" ? <>
        <path d="M10 2h4m-2 12 3-3" />
        <circle cx="12" cy="14" r="8" />
      </> : name === "password" ? <>
        <rect x="5" y="10" width="14" height="11" rx="2" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3m-4 5v2" />
      </> : <>
        <path d="M9 3h6m-5 0v7l-6 9a1.3 1.3 0 0 0 1 2h14a1.3 1.3 0 0 0 1-2l-6-9V3M8 15h8" />
      </>}
    </svg>
  );
}
